import { UnitTour } from '../types/Unit/Unit';
import Label from '../components/Label/Label';
import TourLink from '../components/TourLink/TourLink';
import BedsAndBaths from '../components/BedsAndBaths/BedsAndBaths';

const TABLE_COLUMNS = [
    {
        key: 'unitNumber',
        getValue: (unitTour: UnitTour) => {
            const { unitNumber } = unitTour;
            if (!unitNumber) return null;

            return unitNumber;
        },
        width: '30%',
    },
    {
        key: 'floorPlanType',
        getValue: (unitTour: UnitTour) => unitTour.floorPlanType || null,
        width: '20%',
    },
    {
        key: 'rooms',
        getValue: (unitTour: UnitTour) => <BedsAndBaths unit={unitTour} />,
        width: '30%',
    },
    {
        key: 'unitSize',
        getValue: (unitTour: UnitTour) => {
            if (!unitTour.unitSize) return null;
            const unitOfArea =
                unitTour.unitSize.unitOfArea === 'ft2' ? 'ft' : 'm';
            return (
                <>
                    {unitTour.unitSize.num} {unitOfArea}
                    <sup>2</sup>
                </>
            );
        },
        width: '20%',
    },
    {
        key: 'url',
        getValue: (unitTour: UnitTour) => {
            return unitTour.tour;
        },
        render: (value: string) => {
            if (!value) return <Label>3D&nbsp;Tour Coming&nbsp;Soon</Label>;

            return <TourLink tourId={value} />;
        },
        width: '10%',
    },
];

export default TABLE_COLUMNS;
